<template>
  <div> 
    <CustomDialog ref='pdnProfile' :element='dialog.element.elePdnProfile' :styles='dialog.styles' :messages='dialog.messages.pdnProfile'>
      <template v-slot:dialog-content>
        <div>
          <ejs-grid ref='grid' :dataSource="data" height='100%' :rowDeselected='getCheckedCount' :rowSelected='getCheckedCount' :allowReordering='true' :allowResizing='true'>
            <e-columns>
              <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center' ></e-column>
              <e-column field='profileId' :headerText='$t("Snssai.dnnProfile")' width='20%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='profileName' :headerText='$t("Snssai.dnnProfileName")' width='30%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            </e-columns>
          </ejs-grid>
          <!-- <ejs-pager ref='pager' @click='qryList()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager> -->
        </div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>

import CustomDialog from '../../../../common/CustomDialog';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "DnnProfileList",
  components: {
    CustomDialog,
  }, 
  props: [
    'getCheckedDatas',
  ],
  methods: {
    qryList(ne,profileId) {
      // this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
       const snssaiList = profileId.split(',').filter((item) => { return item !== "" });
       const snssaiList2 = [];
        snssaiList.forEach(element => {
          snssaiList2.push(parseInt(element));
        });
      const params = {
        vo: {
          snssaiProfileIds: snssaiList2,
        }, 
        info: {
          msgid: "28699",
          neid: ne.neid,
        },
        // page: {
        //   pageNo: this.page.pageNo,
        //   pageSize: this.page.pageSize,
        // },
      };
      console.log('params=', params);
      this.$axios.post(ajaxUrl.qryDnnProfileBySnssai, params).then((response) => {
                  console.log("response",response)     

        if (!response) {
          console.log("qryPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryPdnProfile response.data error");
          return;
        }        
        if (!response.data.resultVal) {
          console.log("qryPdnProfile response.data.resultVal error");
          return;
        }    
        const res = response.data.resultVal;
        if (res) {
          this.data = res.dnnProfileInfoJson;   
          console.log("dnnProfileInfoJson", this.data)     
          // this.page.pageCount = res.page;
          // this.page.totalCount = res.countRsp;
          // this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }   
      });
    },
    show() {
      this.$refs.pdnProfile.show();
    },
    save() {
      const checkedKeys = this.getCheckedKeys();
      if(checkedKeys) {
        if(this.getCheckedDatas) {
          this.getCheckedDatas(checkedKeys);
        }
        this.close();
        return;
      }
    },
    close() {
      this.$refs.pdnProfile.clear();
      this.$refs.pdnProfile.close();
    },
    getCheckedRecords() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      return selectedRecords;
    },
    getCheckedKeys() {
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedRecords();
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push(checkedData[i].profileId);
      }
      return profileId.length === 0 ? null : profileId;
    },
    getCheckedCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.checkedCount = selectedRecords.length;
    },
  },
  data() {
    return {
      data: {},
      checkedCount: 0,
      page: {
        pageNo: '1',
        pageSize: '15',
        totalCount: '0',
        pageCount: '0',
      },
      dialog: {
        styles: {
          width: '50%',
          height: '60%',
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          elePdnProfile: {
            target: this.$refs.pdnProfile,
            refName: 'elePdnProfile',
            buttonGroup: [
              { click: this.save, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.close, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Snssai.dnnProfileList"),
            isClose: true,
          },     
        },
        messages: {
          pdnProfile: {
            title: this.$t("Snssai.dnnProfileList"),
          },          
        },
      },      
    };
  },
};
</script>
